var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "park-info-header" }, [
    _c(
      "div",
      { staticClass: "common-card-panel park-info show-radius show-shadow" },
      [
        _c("div", { staticClass: "info-head" }, [
          _c(
            "div",
            { staticClass: "park-name" },
            [
              _c("span", { staticClass: "name" }, [
                _vm._v(
                  _vm._s(
                    (_vm.$route.query && _vm.$route.query.parkName) || "--"
                  )
                ),
              ]),
              _c(
                "el-tag",
                {
                  staticClass: "area-tag",
                  attrs: { color: "#186bfc", size: "small" },
                },
                [
                  _vm._v(
                    _vm._s(
                      (_vm.$route.query && _vm.$route.query.province) || "--"
                    )
                  ),
                ]
              ),
              _c(
                "el-tag",
                {
                  staticClass: "area-tag",
                  attrs: { color: "#186bfc", size: "small" },
                },
                [
                  _vm._v(
                    _vm._s((_vm.$route.query && _vm.$route.query.city) || "--")
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "park-switch-type" },
            _vm._l(_vm.switchTypeOption, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  class: item.value == _vm.switch_type ? "is-active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.switchTypeChange(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "park-industry" }, [
          _c("span", { staticClass: "item-name" }, [
            _vm._v("详细地址：" + _vm._s(_vm.addressName)),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "statistical-panel fx-s-center" },
      _vm._l(_vm.statisticalOption, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "common-card-panel show-shadow show-radius",
          },
          [
            _c("div", [
              _c("span", { staticClass: "panel-icon" }),
              _c("span", { staticClass: "fx-c" }, [
                _c("span", { staticClass: "type" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c("span", { staticClass: "total" }, [
                  _vm._v(
                    _vm._s(
                      item[_vm.switch_type + "Number"] > 0
                        ? _vm.Global.formatThousandSeparator(
                            item[_vm.switch_type + "Number"]
                          )
                        : 0
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }